import React from "react";

export const PlaceholderImgIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="34" viewBox="0 0 20 17" fill="none">
            <g clipPath="url(#clip0_9_1425)">
                <path
                    d="M18.9885 13.3225L13.9274 8.60633C13.5436 8.24855 13.1143 8.0729 12.6394 8.0729C12.1645 8.0729 11.7547 8.24203 11.3644 8.59334L7.55244 11.9955L5.98471 10.5644C5.62693 10.2457 5.25613 10.0765 4.84631 10.0765C4.456 10.0765 4.10473 10.2326 3.76646 10.5513L0.58546 13.4526C0.670027 14.9098 1.22946 15.5994 2.45243 15.5994H16.8157C18.2924 15.5994 18.9819 14.7732 18.9885 13.3225ZM2.53049 16.1263H17.1735C18.8583 16.1263 19.7105 15.2741 19.7105 13.6218V3.34371C19.7105 1.6849 18.8583 0.832733 17.1735 0.832733H2.53049C0.852172 0.832733 0 1.6784 0 3.34371V13.6218C0 15.2871 0.852172 16.1263 2.53049 16.1263ZM2.55651 14.9749C1.64579 14.9749 1.15141 14.4935 1.15141 13.5568V3.40225C1.15141 2.47202 1.64579 1.98414 2.55651 1.98414H17.154C18.0452 1.98414 18.5526 2.47202 18.5526 3.40225V13.5568C18.5526 14.4935 18.0452 14.9749 17.154 14.9749H2.55651Z"
                    fill="#E4E4E4"/>
                <path
                    d="M6.19939 8.58681C7.28574 8.58681 8.17042 7.70213 8.17042 6.60928C8.17042 5.52292 7.28574 4.62521 6.19939 4.62521C5.10653 4.62521 4.22183 5.52292 4.22183 6.60928C4.22183 7.70213 5.10653 8.58681 6.19939 8.58681Z"
                    fill="#E4E4E4"/>
            </g>
            <defs>
                <clipPath id="clip0_9_1425">
                    <rect width="19.9512" height="15.2935" fill="white" transform="translate(0 0.832733)"/>
                </clipPath>
            </defs>
        </svg>
    );
}